import http from '@/plugins/axios';

export default {

    queryStrategyList(data){
        return http.get({
            url: '/admin/hedge/query/strategy',
            data
        })
    },

    queryAllHedgeStrategies(){
        return http.get({
            url: '/admin/hedge/query/all/strategies',
        })
    },

    addStrategy(data){
        return http.post({
            url: '/admin/hedge/add/strategy',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/json'
            }
        })
    },
    updateStrategy(data){
        return http.post({
            url: '/admin/hedge/update/strategy',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/json'
            }
        })
    },
    removeStrategy(data){
        return http.post({
            url: '/admin/hedge/remove/strategy',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/json'
            }
        })
    },
    updateStrategyStatus(data) {
        return http.post({
            url: '/admin/hedge/update/strategy/status',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/json'
            }
        })
    },

    addHedgeFinanceDifference(data) {
        return http.post({
            url: '/admin/hedge/Hedge/addHedgeFinanceDifference',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/json'
            }
        })
    },

    queryHedgeFinanceDifference(data) {
        return http.post({
            url: '/admin/hedge/Hedge/queryHedgeFinanceDifference',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/json'
            }
        })
    },

    queryAllHedgeFinanceDifference(data) {
        return http.post({
            url: '/admin/hedge/Hedge/queryAllFinanceDifference',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/json'
            }
        })
    },

    deleteHedgeFinanceDifference(data) {
        return http.post({
            url: '/admin/hedge/Hedge/deleteFinanceDifference',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/json'
            }
        })
    },

    updateSwitch(data){
        return http.post({
            url: '/admin/hedge/strategy/batchSwitch',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/json'
            }
        })
    },

    updateBatchRetracement(data){
        return http.post({
            url: '/admin/hedge/strategy/batchRetracement',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/json'
            }
        })
    }


}
